import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-8 mx-auto" }
const _hoisted_3 = { class: "input-group input-group-sm mb-3" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "d-block text-muted small font-monospace" }
const _hoisted_8 = { class: "col-sm-5" }
const _hoisted_9 = {
  key: 0,
  class: "form-check form-switch"
}
const _hoisted_10 = ["id", "checked", "disabled", "onChange"]
const _hoisted_11 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_12 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_13 = ["onUpdate:modelValue", "id", "readonly"]
const _hoisted_14 = ["onUpdate:modelValue", "type", "id", "readonly"]
const _hoisted_15 = {
  key: 4,
  class: "form-text text-muted d-block"
}
const _hoisted_16 = {
  key: 5,
  class: "form-text text-muted d-block"
}
const _hoisted_17 = { class: "col-sm-3 text-end" }
const _hoisted_18 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_CollapsibleCard = _resolveComponent("CollapsibleCard")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "settingsLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              type: "search",
              class: "form-control",
              placeholder: _ctx.helper.trans('system_settings.search_placeholder')
            }, null, 8, _hoisted_4), [
              [_vModelText, _ctx.search]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary text-nowrap",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAllCategories && _ctx.toggleAllCategories(...args)))
            }, _toDisplayString(_ctx.allCategoriesOpen ? _ctx.helper.trans('system_settings.collapse_all') : _ctx.helper.trans('system_settings.expand_all')), 1)
          ]),
          (_ctx.groups.length > 0 && _ctx.visibleGroups.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.helper.trans('system_settings.nothing_found')), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleGroups, (group) => {
            return (_openBlock(), _createBlock(_component_CollapsibleCard, {
              key: group.category,
              title: _ctx.getGroupTitle(group),
              count: group.items.length,
              open: _ctx.isCategoryOpen(group.category),
              onToggle: ($event: any) => (_ctx.toggleCategory(group.category))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (setting) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: _ctx.getSystemSettingId(setting),
                    class: "mb-3 row"
                  }, [
                    _createElementVNode("label", {
                      for: 'setting-' + _ctx.getSystemSettingId(setting),
                      class: "col-sm-4 col-form-label text-capitalize-first"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.getSettingTitle(setting)) + " ", 1),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getSystemSettingId(setting)), 1)
                    ], 8, _hoisted_6),
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.isBooleanSystemSetting(setting))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("input", {
                              id: 'setting-' + _ctx.getSystemSettingId(setting),
                              class: "form-check-input",
                              type: "checkbox",
                              role: "switch",
                              checked: _ctx.isSettingChecked(setting),
                              disabled: _ctx.isSettingDisabled(setting),
                              onChange: ($event: any) => (_ctx.onBooleanChange(setting, $event))
                            }, null, 40, _hoisted_10)
                          ]))
                        : (_ctx.isMultiselectSystemSetting(setting))
                          ? (_openBlock(), _createBlock(_component_Multiselect, {
                              key: 1,
                              id: 'setting-' + _ctx.getSystemSettingId(setting),
                              "model-value": _ctx.getListSettingValue(setting),
                              "onUpdate:modelValue": (value) => _ctx.setListSettingValue(setting, value),
                              options: _ctx.getSettingOptions(setting),
                              "custom-label": (opt) => _ctx.getOptionLabel(setting, opt),
                              multiple: true,
                              searchable: true,
                              taggable: _ctx.isTaggableSetting(setting),
                              onTag: (value) => _ctx.addSettingTag(setting, value),
                              disabled: setting.readOnly === true,
                              "select-label": "",
                              "deselect-label": "",
                              "tag-placeholder": _ctx.helper.trans('system_settings.add_value'),
                              placeholder: _ctx.getSettingTitle(setting)
                            }, {
                              option: _withCtx((props) => [
                                _createElementVNode("div", _hoisted_11, [
                                  (_ctx.isPayMethodOptionsSetting(setting))
                                    ? (_openBlock(), _createBlock(_component_PayMethodIcon, {
                                        key: 0,
                                        "icon-class": "icon",
                                        method: props.option
                                      }, null, 8, ["method"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getOptionLabel(setting, props.option)), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["id", "model-value", "onUpdate:modelValue", "options", "custom-label", "taggable", "onTag", "disabled", "tag-placeholder", "placeholder"]))
                          : (_ctx.isJsonSystemSetting(setting))
                            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                key: 2,
                                "onUpdate:modelValue": ($event: any) => ((setting.value) = $event),
                                id: 'setting-' + _ctx.getSystemSettingId(setting),
                                rows: "4",
                                class: "form-control form-control-sm font-monospace",
                                readonly: setting.readOnly === true
                              }, null, 8, _hoisted_13)), [
                                [_vModelText, setting.value]
                              ])
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 3,
                                "onUpdate:modelValue": ($event: any) => ((setting.value) = $event),
                                type: _ctx.useNumberInput(setting) ? 'number' : 'text',
                                id: 'setting-' + _ctx.getSystemSettingId(setting),
                                class: "form-control form-control-sm",
                                readonly: setting.readOnly === true
                              }, null, 8, _hoisted_14)), [
                                [_vModelDynamic, setting.value]
                              ]),
                      (_ctx.getSettingHint(setting))
                        ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.getSettingHint(setting)), 1))
                        : _createCommentVNode("", true),
                      (setting.readOnly === true)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(_ctx.helper.trans('system_settings.read_only_hint')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _withModifiers(($event: any) => (_ctx.saveSettings(setting)), ["prevent"]),
                        class: "btn btn-sm btn-primary text-capitalize-first",
                        disabled: _ctx.isSaveDisabled(setting)
                      }, _toDisplayString(_ctx.helper.trans("labels.save_changes")), 9, _hoisted_18)
                    ])
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["title", "count", "open", "onToggle"]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 512))
}